export default __webpack_public_path__ + "static/media/502.1191975c.png";